import AddIcon from '@mui/icons-material/Add'
import { ButtonBase, Paper, Stack, Typography } from '@mui/material'
import React from 'react'

export interface AddTileProps {
  label: string
  height?: number
  onClick: () => void
}

/** The last tile in a grid: adding is where the eye already is, not only in the header. */
export default function AddTile({ label, height = 150, onClick }: AddTileProps) {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{ width: '100%', textAlign: 'left', borderRadius: 1 }}
      data-testid="grid-add-tile"
    >
      <Paper
        variant="outlined"
        sx={{
          width: '100%',
          height,
          borderStyle: 'dashed',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Stack alignItems="center" spacing={0.5}>
          <AddIcon color="action" />
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
        </Stack>
      </Paper>
    </ButtonBase>
  )
}
